require("./bootstrap");

import "tw-elements";

import Vue from "vue";
var token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common["X-CSRF-TOKEN"] = token.content;
} else {
    console.error(
        "CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token"
    );
}

const numberFormats = {
    "it-IT": {
        currency: {
            style: "currency",
            currency: "CHF",
            currencyDisplay: "symbol",
        },
    },
    "de-CH": {
        currency: {
            style: "currency",
            currency: "CHF",
            currencyDisplay: "symbol",
        },
    },
    "en-US": {
        currency: {
            style: "currency",
            currency: "USD",
        },
    },
};

import VueI18n from "vue-i18n";
Vue.use(VueI18n);
const i18n = new VueI18n({
    numberFormats,
});

import VueMoment from "vue-moment";
Vue.use(VueMoment);

import UpcomingCourses from "./components/website/UpcomingCourses.vue";
Vue.component("upcoming-courses", UpcomingCourses);

import CourseApply from "./components/website/CourseApply.vue";
Vue.component("course-apply", CourseApply);

new Vue({
    el: "#app",
    i18n,
});

function BackToTop(element) {
    const VISIBLE_HEIGHT = 300;

    var $ = window.$;

    var toggler = $(element);
    var $window = $(window);

    checkVisibility();

    toggler.on("click", backToTop);
    $window.on("scroll", checkVisibility);

    function checkVisibility() {
        if ($window.scrollTop() > VISIBLE_HEIGHT) {
            toggler.removeClass("hidden");
        } else {
            toggler.addClass("hidden");
        }
    }

    function backToTop() {
        $("html, body").animate(
            {
                scrollTop: 0,
            },
            700
        );
    }
}

new BackToTop(".btn-back-to-top");
